import { getFetchWrapper } from './fetchHelpers'

export function initPDPFomoStats () {
  const viewStats = document.getElementById('vjs-listing__stats-views')
  const cartStats = document.getElementById('vjs-listing__stats-cart')
  if (!viewStats) return
  if (!cartStats) return

  getFetchWrapper(listingStatsUrl()).then(response => response.json()).then(data => {
    const othersWatchingCount = data.num_people_interested_in_listing
    const othersHaveInCartCount = data.num_people_with_listing_in_basket

    if (othersHaveInCartCount && othersHaveInCartCount > 0) {
      cartStats.classList.remove('hidden')
      document.getElementById('vjs-listing__stats-cart-text').innerHTML = fomoStatText(cartStats, othersHaveInCartCount)
    }
    if (othersWatchingCount && othersWatchingCount > 0) {
      viewStats.classList.remove('hidden')
      document.getElementById('vjs-listing__stats-views-text').innerHTML = fomoStatText(viewStats, othersWatchingCount)
    }
  }).catch(error => {
    viewStats.style.display = 'none'
    cartStats.style.display = 'none'
    console.log('ERROR:', error)
  })
}

function fomoStatText (element, count) {
  const template = count === 1 ? element.dataset.textOne : element.dataset.textOther
  return template.replace('{count}', `<span class="font-bold">${count}</span>`)
}

function listingStatsUrl () {
  const listingSlugElement = document.querySelector('[data-id="content-listing-slug"]')
  if (!listingSlugElement) return
  const listingSlug = listingSlugElement.innerHTML

  return '/listings/' + listingSlug + '/stats'
}
